'use client';
import {Content, Portal, Overlay} from '@radix-ui/react-dialog';
import {PropsWithChildren, useState} from 'react';
import XIcon from '../Icons/X';

import {cn} from '@/lib/utils';
import './styles.css';

type Props = PropsWithChildren & {
  onOpenChange: (open: boolean) => void;
  preventOutsideClick?: boolean;
  contentCustomClass?: string;
  buttonCustomClass?: string;
  hideXButton?: boolean;
};

export default function ModalContent({
  children,
  onOpenChange,
  preventOutsideClick = false,
  contentCustomClass,
  buttonCustomClass,
  hideXButton = false,
}: Props) {
  const [willUnmount, setWillUnmount] = useState(false);

  const handleOpenAutoFocus = () => {
    setWillUnmount(false);
  };

  const handleCloseDatePicker = () => {
    setWillUnmount(true);
    setTimeout(() => {
      onOpenChange(false);
    }, 200);
  };

  return (
    <Portal>
      <Overlay
        className={cn('DialogOverlay', {
          UnmountOverlay: willUnmount,
        })}>
        <Content
          onOpenAutoFocus={handleOpenAutoFocus}
          onInteractOutside={(e) => {
            e.preventDefault();
            preventOutsideClick || handleCloseDatePicker();
          }}
          className={cn(`DialogContent ${contentCustomClass}`, {
            UnmountDialog: willUnmount,
          })}>
          {hideXButton || (
            <button
              onClick={handleCloseDatePicker}
              className={`DialogClose text-gray-500 ${buttonCustomClass}`}>
              <XIcon className="w-6 h-6 m-auto fill-current z-50" />
            </button>
          )}
          {children}
        </Content>
      </Overlay>
    </Portal>
  );
}
